import { createSelector } from "reselect"
import { get, chain } from "lodash"
import moment from "moment"
import { getStartDate, getEndDate } from "selectors/dates"
import { getBaseStartDate } from "./base"

const getRawBaseCoverage = state => get(state, "global.data.baseCoverage.data.model.simulation.coverage")

export const getHasEnoughBaseModelCoverage = createSelector(
  [getRawBaseCoverage],
  (baseCoverage) => !baseCoverage || chain(baseCoverage).map(elem => get(elem, "summary.percentGmvAvailable", 0)).mean().value() > 0.5,
)

export const getBaseCoverageStartDate = createSelector(
  [getStartDate, getEndDate, getBaseStartDate],
  (startDate, endDate, baseStartDate) => {
    if (!endDate || !startDate) {
      return null
    }

    if (baseStartDate && startDate < baseStartDate) {
      startDate = baseStartDate
    }

    const computedStartDate = moment(endDate).subtract(1, "y").format("YYYY-MM-DD")
    if (computedStartDate < startDate) {
      return startDate
    }

    return computedStartDate
  },
)
